import React from 'react';
import { useEffect, useState } from "react";
import { sdmUrl, username, password } from '../Api';
import { encode } from "base-64";


export function CustomerData(){

    let base64 = require('base-64');
    const [options, setOptions] = React.useState([""]);

    useEffect(() => {
        const getCustomerData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/holibook/customer_dropdown') , {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + base64.encode(username + ":" + password)
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setOptions(arr)
                });

            } catch (error) {
                console.log(error);
            }
        }
        getCustomerData();
    }, []);

    return {options};
}

export function IndustryVerticle(){

    let base64 = require('base-64');
    const [IndustryVertOptions, setIndustryVertOptions] = React.useState([""]);

    useEffect(() => {
        const getIndustryVertData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/holibook/industry_vertical') , {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + base64.encode(username + ":" + password)
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setIndustryVertOptions(arr)
                });

            } catch (error) {
                console.log(error);
            }
        }
        getIndustryVertData();
    }, []);

    return {IndustryVertOptions};
}


export function LocationData(){

    let base64 = require('base-64');
    const [locationOptions, setLocationOptions] = React.useState([""]);

    useEffect(() => {
        const getlocationtData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/holibook/location_oem_dropdown') , {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + base64.encode(username + ":" + password)
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setLocationOptions(arr)
                });

            } catch (error) {
                console.log(error);
            }
        }
        getlocationtData();
    }, []);

    return {locationOptions};
}


export function DistrictData(){

    let base64 = require('base-64');
    const [districtOptions, setDistrictOptions] = React.useState([""]);

    useEffect(() => {
        const getDistrictData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/holibook/district_dropdown') , {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + base64.encode(username + ":" + password)
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setDistrictOptions(arr)
                });

            } catch (error) {
                console.log(error);
            }
        }
        getDistrictData();
    }, []);

    return {districtOptions};
}


export function ComponentFamily(){

    const usr_token = localStorage.getItem('authToken');
    //const usr_token = "167283765161839864";
    const [comFamOptions, setComFamOptions] = React.useState([""]);

    useEffect(() => {
        const getComFamilyData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/family/list'), {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.name });
                    });
                    setComFamOptions(arr)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getComFamilyData();
    }, []);

    return {comFamOptions};
}

export function LeadSource(){

    const usr_token = localStorage.getItem('authToken');
    //const usr_token = "167283765161839864";
    const [leadsourceOptions, setLeadSourceOptions] = React.useState([""]);

    useEffect(() => {
        const getLeadSourceData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/lead_source/list'), {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.name });
                    });
                    setLeadSourceOptions(arr)
                });

            } catch (error) {
                console.log(error);
            }
        }
        getLeadSourceData();
    }, []);

    return {leadsourceOptions};
}


export function SupLocationAdd(){

    let base64 = require('base-64');
    const [supplocAddOptions, setsuppLocAddOptions] = React.useState([""]);

    useEffect(() => {
        const getLocationAddData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/holibook/location_supp_addr_dropdown') , {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + base64.encode(username + ":" + password)
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setsuppLocAddOptions(arr)
                });

            } catch (error) {
                console.log(error);
            }
        }
        getLocationAddData();
    }, []);

    return {supplocAddOptions};
}

export function OemLocationAdd(){

    let base64 = require('base-64');
    const [oemlocAddOptions, setOemLocAddOptions] = React.useState([""]);

    useEffect(() => {
        const getOemLocationAddData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/holibook/location_oem_addr_dropdown') , {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + base64.encode(username + ":" + password)
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setOemLocAddOptions(arr)
                });

            } catch (error) {
                console.log(error);
            }
        }
        getOemLocationAddData();
    }, []);

    return {oemlocAddOptions};
}

export function PincodeData(){

    let base64 = require('base-64');
    const [pincodeOptions, setPincodeOptions] = React.useState([""]);

    useEffect(() => {
        const getPincodeData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/holibook/pincode_dropdown') , {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + base64.encode(username + ":" + password)
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setPincodeOptions(arr)
                });

            } catch (error) {
                console.log(error);
            }
        }
        getPincodeData();
    }, []);

    return {pincodeOptions};
}

export function LeadCount(){

    const usr_token = localStorage.getItem('authToken');
    const [leadCountData, setLeadCountData] = React.useState([""]);

    useEffect(() => {
        const getleadCountData = async () => {
            try {
                fetch(sdmUrl.concat('/dashboard/dashboard_item_count') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {
                
                    let result = response.data;
                    setLeadCountData(result)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getleadCountData();
    }, []);

    return {leadCountData};
}

export function UserList(){

    const usr_token = localStorage.getItem('authToken');
    const [userData, setUserData] = React.useState([""]);

    useEffect(() => {
        const getUserData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/user/list') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.name });
                    });
                    setUserData(arr)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getUserData();
    }, []);

    return {userData};
}

export function PermissionList(){

    const usr_token = localStorage.getItem('authToken');
    const [permissionData, setPermissisonData] = React.useState([""]);

    useEffect(() => {
        const getPermissionData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/img/configs') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    // result?.map((data) => {
                    //     return arr.push({ value: data.id, label: data.name });
                    // });
                    setPermissisonData(result)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getPermissionData();
    }, []);

    return {permissionData};
}

export function BDUserList(){

    let base64 = require('base-64');
    const [bdUserListData, setBDUserListData] = React.useState([""]);

    useEffect(() => {
        const getBDUserListData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/holibook/bd_user_dropdown') , {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + base64.encode(username + ":" + password)
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setBDUserListData(arr)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getBDUserListData();
    }, []);

    return {bdUserListData};
}

export function UserPermissionList(){

    const usr_token = localStorage.getItem('authToken');
    const [permissionList, setPermissionList] = React.useState([""]);

    useEffect(() => {
        const getPermissionListData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/user/permission_list') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ menuid: data.menu_id, web: data.use_for_web });
                    });
                    setPermissionList(arr)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getPermissionListData();
    }, []);

    return {permissionList};
}

export function ListView(){

    const usr_token = localStorage.getItem('authToken');
    const [listViewData, setListViewData] = React.useState([""]);

    useEffect(() => {
        const getListViewData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/sdm_lead/view') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    // result?.map((data) => {
                    //     return arr.push({ value: data.menu_name, label: data.use_for_web });
                    // });
                    setListViewData(result)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getListViewData();
    }, []);

    return {listViewData};
}

export function RoleList(){

    const usr_token = localStorage.getItem('authToken');
    const [roleListData, setRoleListData] = React.useState([""]);

    useEffect(() => {
        const getRoleListData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/role/list') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.name });
                    });
                    setRoleListData(arr)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getRoleListData();
    }, []);

    return {roleListData};
}

export function LOBList(){

    const usr_token = localStorage.getItem('authToken');
    const [lobListData, setLobListData] = React.useState([""]);

    useEffect(() => {
        const getLobListData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/filter/lob') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setLobListData(arr)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getLobListData();
    }, []);

    return {lobListData};
}


export function ProductList(){

    const usr_token = localStorage.getItem('authToken');
    const [productListData, setProductListData] = React.useState([""]);

    useEffect(() => {
        const getProductListData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/filter/product') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setProductListData(arr)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getProductListData();
    }, []);

    return {productListData};
}

export function ServicesList(){

    const usr_token = localStorage.getItem('authToken');
    const [servicesListData, setServicesListData] = React.useState([""]);

    useEffect(() => {
        const getServicesListData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/filter/services') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setServicesListData(arr)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getServicesListData();
    }, []);

    return {servicesListData};
}

export function OperationTypeList(){

    const usr_token = localStorage.getItem('authToken');
    const [operatTypeListData, setOperatTypeListData] = React.useState([""]);

    useEffect(() => {
        const getOperatTypeListData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/mst/operation_type') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setOperatTypeListData(arr)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getOperatTypeListData();
    }, []);

    return {operatTypeListData};
}

export function BDList(){

    const usr_token = localStorage.getItem('authToken');
    const [bdListData, setBDListData] = React.useState([""]);

    useEffect(() => {
        const getBDListData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/mst/bd_list') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setBDListData(arr)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getBDListData();
    }, []);

    return {bdListData};
}

export function SDList(){

    const usr_token = localStorage.getItem('authToken');
    const [sdListData, setSDListData] = React.useState([""]);

    useEffect(() => {
        const getSDListData = async () => {
            const arr = [];
            try {
                fetch(sdmUrl.concat('/mst/sd_list') , {
                    method: 'POST',
                    body: JSON.stringify({ usr_token }),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>
                    response.json()
                )
                .then((response) => {  
                    let result = response.data;
                    result?.map((data) => {
                        return arr.push({ value: data.id, label: data.value });
                    });
                    setSDListData(arr)
                });
            } catch (error) {
                console.log(error);
            }
        }
        getSDListData();
    }, []);

    return {sdListData};
}

